import { useTempoConfig } from "../../TempoProvider";
export const useBadgeUrl = (type, { overrideImgUrl, locale = 'en' })=>{
    const { cdnUrl } = useTempoConfig();
    return overrideImgUrl !== null && overrideImgUrl !== void 0 ? overrideImgUrl : `${cdnUrl}/common/images/${type}-store-badge/${locale}.svg`;
};

//# sourceMappingURL=common.js.map